module.exports = __webpack_public_path__ + "static/media/black-info-icon.223d0114.svg";